<template>
	<div class="company">
		<div class="container">
			<div v-for="item in newsList" class="comnewlist clearfix" @click="gotoDetail(item.nid)">
				<div class="left">
					<img :src="item.img"/>
				</div>
				<div class="center">
					<h2>{{item.title}}</h2>
					<p class="time"><span>发布时间：</span>{{item.addtime}}</p>
					<p>{{item.summary}}</p>
				</div>
			</div>
		</div>
		<el-pagination
            @current-change="handleCurrentChange"
			background
			layout="prev, pager, next"
			v-if="total>1?true:false"
			:total="total"
			style="float:right">
		</el-pagination>
		<div style="clear:both;margin-bottom:20px;"></div>
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		id:'',
		data(){
			return{
				msg:"公司新闻",
				newsList:[],
				total:1,
				pagesize:2,
				currentPage:1,
			}
		},
		methods:{
			gotoDetail(id){
				this.$router.push({
				          	path: '/NewDetail',
				          	query: {
				          		id:	 id,         
				          	}
				      	})
			},
			getNewsList(id){
				this.axios({
					method: 'get',
					url: this.GLOBAL.newsMainApi+id+'/page/'+this.currentPage,
					data: {}
				})
				.then((res) => {
					this.newsList = res.data.data;
					this.total = parseInt(res.data.total);
					this.id = id;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			handleCurrentChange: function(currentPage){
                this.currentPage = currentPage;
                this.getNewsList(this.id);
	        }
		},
		created(){
			this.handleCurrentChange();
		},
	}
</script>

<style lang="less" scoped="scoped">
@import url("../../../../styles/main.less");
.company{
	.margin-top(60);
	.comnewlist{
		width: 100%;
		.margin-bottom(30);
		.padding(10,10,10,10);
		background: #f7f7f7;
		.left{
			display: inline-block;
			width: 24%;
			height: 100%;
			float: left;
			img{
				width: 100%;
				height: 100%;
			}
		}
		.center{
			display: inline-block;
			width: 75%;
			height: 100%;
			float: left;
			.padding-left(30);
			.time{
				.font-size(20);
				span{
					color:#8b8b8b
				}
			}
			h2{
				.font-size(30);
				font-weight: 600;
				.margin-bottom(10);
			}
			p{
				width: 100%;
				overflow: hidden;
				.padding(7,7,7,7);
				.font-size(24);
				display: -webkit-box;
				/* -webkit-box-orient: vertical; */
				/*! autoprefixer: off */
				-webkit-box-orient: vertical;
				/* autoprefixer: on */
				-webkit-line-clamp: 2;
				overflow: hidden;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/NewCenter/Ncom/NewsList.vue